import { useState, useEffect } from "react";
import { toast } from 'react-toastify';

const InventoryVendor = () => {
  const [vendors, setVendors] = useState([]);
  const [viewMode, setViewMode] = useState("vendor");
  const [fileData, setFileData] = useState([]);
  const [vendorName, setVendorName] = useState("");
  const [vendorCost, setVendorCost] = useState("");
  const [vendorCountry, setVendorCountry] = useState(""); // Add state for country
  const [vendorEmail, setVendorEmail] = useState(""); // Add state for email
  const [vendorPhone, setVendorPhone] = useState(""); // Add state for phone number

  // Load vendors from localStorage on initial load
  useEffect(() => {
    const savedVendors = JSON.parse(localStorage.getItem("vendors"));
    if (savedVendors) {
      setVendors(savedVendors);
    }
  }, []);

  // Save vendors to localStorage whenever they change
  useEffect(() => {
    if (vendors.length > 0) {
      localStorage.setItem("vendors", JSON.stringify(vendors));
    }
  }, [vendors]);

  // Add a new vendor
  const handleAddVendor = () => {
    if (!vendorName || !vendorCost || !vendorCountry || !vendorEmail ) {
      return toast.error("Please enter all fields.");
    }

    const newVendor = {
      name: vendorName,
      cost: vendorCost,
      country: vendorCountry,
      email: vendorEmail,
      phone: vendorPhone,
    };

    setVendors([...vendors, newVendor]);
    setVendorName("");
    setVendorCost("");
    setVendorCountry("");
    setVendorEmail("");
    toast.error('Vendor Added Successfully!');
    setViewMode("vendor"); // Redirect to vendor details after adding the vendor
  };

  // Button to View Vendor Details
  const handleViewVendorDetails = () => {
    setViewMode("vendorDetails");
  };
   // Button to View Vendor Details
   const handleViewVendor = () => {
    setViewMode("vendor");
  };

  return (
    <div className="w-full h-full space-y-8 bg-white shadow-xl rounded-lg p-8 border border-[#96989a]">
      <h2 className="text-5xl font-bold text-gray-700 ">Inventory Management</h2>
     
      {viewMode === "vendor" && (
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-6">
            {/* Vendor Name */}
            <div>
              <label className=" flex  text-sm font-semibold text-gray-700 mb-2" htmlFor="vendorName">
                Vendor Name <p className="flex text-red-500">*</p>
              </label>
              <input
                type="text"
                id="vendorName"
                placeholder="Vendor Name"
                value={vendorName}
                onChange={(e) => setVendorName(e.target.value)}
                className="w-full p-2 border border-gray-600 rounded-md"
              />
            </div>

            {/* Country */}
            <div>
              <label className="flex text-sm font-semibold text-gray-700 mb-2" htmlFor="vendorCountry">
                Country <p className="flex text-red-500">*</p>
              </label>
              <input
                type="text"
                id="vendorCountry"
                placeholder="Country"
                value={vendorCountry}
                onChange={(e) => setVendorCountry(e.target.value)} // Update country
                className="w-full p-2 border border-gray-600 rounded-md"
              />
            </div>

            {/* Address */}
            <div>
              <label className="flex text-sm font-semibold text-gray-700 mb-2" htmlFor="vendorCost">
                Address
              </label>
              <input
                type="text"
                id="vendorCost"
                placeholder="Address"
                value={vendorCost}
                onChange={(e) => setVendorCost(e.target.value)}
                className="w-full p-2 border border-gray-600 rounded-md"
              />
            </div>

            {/* Email */}
            <div>
              <label className="flex text-sm font-semibold text-gray-700 mb-2" htmlFor="vendorEmail">
                Email <p className="flex text-red-500">*</p>
              </label>
              <input
                type="email"
                id="vendorEmail"
                placeholder="Email"
                value={vendorEmail}
                onChange={(e) => setVendorEmail(e.target.value)} // Update email
                className="w-full p-2 border border-gray-600 rounded-md"
              />
            </div>

            {/* Phone Number */}
            <div>
              <label className="flex text-sm font-semibold text-gray-700 mb-2" htmlFor="vendorPhone">
                Phone Number
              </label>
              <input
                type="number"
                id="vendorPhone"
                placeholder="Phone Number"
                value={vendorPhone}
                onChange={(e) => setVendorPhone(e.target.value)} // Update phone number
                className="w-full p-2 border border-gray-600 rounded-md"
              />
             
            </div>
            <div>

            <label className="flex text-sm font-semibold text-gray-700 mb-2" htmlFor="vendorPhone">
                Contact Person <p className="flex text-red-500">*</p>
              </label>
              <input
                type="text"
                id="contactperson"
                placeholder="Contact Person"
                className="w-full p-2 border border-gray-600 rounded-md"
              />
            </div>


          </div>

          <div className="flex justify-end space-x-4"> 
            <button
              onClick={handleAddVendor}
              className="bg-[#117575] rounded-full p-4 text-white shadow-md hover:bg-[#1cbebe] transition duration-200 "

            >
              Add Vendor
            </button>
            <button
              onClick={handleViewVendorDetails}
              className="bg-teal-500 rounded-full p-4 text-white shadow-md hover:bg-[#1cbebe] transition duration-200"
            >
              View Vendor Details
            </button>
          </div>
        </div>
      )}

      {viewMode === "details" && fileData.length > 0 ? (
        <table className="w-full border rounded-md shadow-sm mt-4">
          <thead className="bg-gray-200">
            <tr>
              {Object.keys(fileData[0]).map((key, index) => (
                <th key={index} className="py-2 px-4 border">{key}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {fileData.map((row, rowIndex) => (
              <tr key={rowIndex} className="border-t">
                {Object.values(row).map((value, colIndex) => (
                  <td key={colIndex} className="py-2 px-4 border">{value}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="text-red-500 text-center mt-4"></p>
      )}

      {/* Vendor Details Table */}
      {viewMode === "vendorDetails" && vendors.length > 0 ? (
        <>
        <table className="w-full border rounded-md shadow-sm mt-4">
          <thead className="bg-gray-200">
            <tr>
              <th className="py-2 px-4 border">Vendor Name</th>
              <th className="py-2 px-4 border">Country</th>
              <th className="py-2 px-4 border">Email</th>
              <th className="py-2 px-4 border">Phone Number</th>
              <th className="py-2 px-4 border">Address</th>
              <th className="py-2 px-4 border">Action</th>
            </tr>
          </thead>
          <tbody>
            {vendors.map((vendor, index) => (
              <tr key={index} className="border-t">
                <td className="py-2 px-4 border">{vendor.name}</td>
                <td className="py-2 px-4 border">{vendor.country}</td>
                <td className="py-2 px-4 border">{vendor.email}</td>
                <td className="py-2 px-4 border">{vendor.phone || 'NA'}</td>
                <td className="py-2 px-4 border">{vendor.cost}</td> {/* Updated field name */}
                <td className="py-2 px-4 border"><button className="self-stretch shadow-[0px_2px_8px_rgba(92,_152,_140,_0.3)] rounded-xl bg-brand-green-selected flex flex-row items-center justify-center p-2.5 box-border text-brand-white">Edit</button>                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <button
        onClick={handleViewVendor}
        className="bg-purple-500 text-white px-4 py-2 rounded-md hover:opacity-80"
      >
        Add Vendor
      </button>
        </> 
      ) : viewMode === "vendorDetails" ? (
        <p className="text-red-500 text-center mt-4">No vendors found.</p>
      ) : null}
    </div>
  );
};

export default InventoryVendor;
